import toastr from 'toastr';
import Vue from 'vue';

const initialCan = {
  editRoles: false,
  add: false,
};

export const RepositoryMembers = {
  namespaced: true,

  state: {
    updatingRepositoryMember: false,
    deletingMember: false,
    savingMember: false,
    loadedList: false,
    approving: false,
    rejecting: false,
    pagination: {},
    list: [],
    can: {
      ...initialCan,
    },
  },

  getters: {
    updatingRepositoryMember: ({ updatingRepositoryMember }) => updatingRepositoryMember,

    deletingMember: ({ deletingMember }) => deletingMember,

    isSavingMember: ({ savingMember }) => savingMember,

    isApprovingMember: ({ approving }) => approving,

    isRejectingMember: ({ rejecting }) => rejecting,

    userCanAddMembers: ({ can }) => Boolean(can?.add),

    canEdit: ({ can }) => !!can?.edit ?? false,

    pagination: ({ pagination }) => pagination,

    loadedList: ({ loadedList }) => loadedList,

    canAdd: ({ can }) => !!can?.add ?? false,

    membersList: ({ list }) => list,
  },

  mutations: {
    setLoadedList(state, loadedList) {
      state.loadedList = loadedList;
    },

    setPagination(state, pagination) {
      state.pagination = pagination;
    },

    deleteMember(state, uuid) {
      const { list } = state;

      state.list = list.filter((m) => m.uuid !== uuid);
    },

    setList(state, list) {
      state.list = list;
    },

    resetList(state) {
      state.list = [];
    },

    setCan(state, can) {
      Vue.set(state, 'can', can);
    },

    setSavingMember(state, bool) {
      state.savingMember = bool;
    },

    setApprovingMember(state, bool) {
      state.approving = bool;
    },

    setRejectingMember(state, bool) {
      state.rejecting = bool;
    },

    setUpdatingRepositoryMember(state, bool) {
      Vue.set(state, 'updatingRepositoryMember', bool);
    },

    setDeletingMember(state, bool) {
      Vue.set(state, 'deletingMember', bool);
    },
  },

  actions: {
    async loadMembers({ commit }, { repository, filter, page, perPage, sortBy, sortDesc, uuids }) {
      if (!repository) return;

      let members = [];
      let pagination = {};
      let can = {
        ...initialCan,
      };

      commit('setLoadedList', false);
      commit('resetList');
      try {
        const response = await this._vm.$api('repositories.members.index', {
          version: '1.0',
          repository,
          sortDesc,
          perPage,
          filter,
          sortBy,
          uuids,
          page,
        });

        can = response.data.can;
        members = response.data.data;
        pagination = { ...response.data.meta, ...response.data.links };
      } catch (err) {
        console.error(err);
      }

      commit('setCan', can);
      commit('setList', members);
      commit('setPagination', pagination);

      commit('setLoadedList', true);
    },

    async updateMember({ commit }, { repository, member, newData, comment }) {
      commit('setUpdatingRepositoryMember', true);
      try {
        await this._vm.$api(
          'repositories.members.update',
          {
            version: '1.0',
            repository,
            member,
          },
          {
            sites: newData.siteUuids ?? [],
            role_id: newData.roleId,
            comment,
          }
        );
      } catch (err) {
        console.log(err);
      }
      commit('setUpdatingRepositoryMember', false);
    },

    async deleteMember({ commit }, { repository, member, comment }) {
      commit('setDeletingMember', true);
      commit('deleteMember', member);
      await this._vm.$api(
        'repositories.members.destroy',
        {
          version: '1.0',
          repository,
          member,
        },
        {
          comment,
        }
      );
      commit('setDeletingMember', false);
    },

    async approveMember({ commit }, { repository, member, comment }) {
      commit('setApprovingMember', true);
      await this._vm.$api(
        'repositories.members.sign',
        {
          version: '1.0',
          repository,
          member,
        },
        {
          comment,
          action: 'approve',
        }
      );
      commit('setApprovingMember', false);
    },

    async rejectMember({ commit }, { repository, member, comment }) {
      commit('setRejectingMember', true);
      await this._vm.$api(
        'repositories.members.sign',
        {
          version: '1.0',
          repository,
          member,
        },
        {
          comment,
          action: 'reject',
        }
      );
      commit('setRejectingMember', false);
    },

    resetMembers({ commit }) {
      commit('resetList');
    },
  },
};
